<script setup lang="ts">
import { ref, computed } from 'vue'
import type { NavigationItem } from '~/models/navigation/NavigationItems.model'
import { useBreadcrumb } from '~/composables/useBreadcrumb'
import type { FooterLink } from '~/models/layouts/footer.model'

const { t } = useI18n()
const isCollapsed = ref(false)
const { userName, logout } = useEntraAuth()
const userMail = ref('')
const userImage = ref('')
const companyName = ref('Chargecloud')
const navigationItems = computed<NavigationItem[]>(() => [
  {
    label: t('nav.main.dashboard'),
    icon: 'fa6-solid:gauge-high',
    to: '/',
  },
  {
    label: t('nav.main.simcards'),
    icon: 'fa6-solid:sim-card',
    to: '/simcards',
  },
  {
    label: t('nav.main.import'),
    icon: 'fa6-solid:file-import',
    to: '/import',
  },
  {
    label: t('nav.main.reports'),
    icon: 'fa6-solid:file-invoice',
    to: '/reports',
  },
])
const userMenuItems = computed<NavigationItem[]>(() => [
  { label: t('nav.user.logout'), icon: 'fa6-solid:arrow-right-from-bracket', action: logout },
])
const footerLinks: FooterLink[] = []
const { breadcrumbItems } = useBreadcrumb()
</script>

<template>
  <NuxtLayout
    v-model:is-collapsed="isCollapsed"
    name="base"
    :user-name="userName"
    :user-mail="userMail"
    :user-image="userImage"
    :company-name="companyName"
    :navigation-items="navigationItems"
    :footer-links="footerLinks"
    :user-menu-items="userMenuItems"
    :breadcrumb-items="breadcrumbItems"
  >
    <slot />
  </NuxtLayout>
</template>
